import React, { useState } from 'react';
import * as  styles from './styles.scss';

const TOGGLE_ICONS = {
    OFFER: styles.offer,
    COUPON: styles.coupon,
    GIFT: styles.gift,
    CASH: styles.cash,
};

const Toggle = ({ isOpen = false, text, children, icon  }) => {
    const [toggle, setToggle] = useState(isOpen);

    return (
        <div className={styles.toggle}>
            <button
                className={`${styles.btn} ${toggle ? styles.up : styles.down}${icon ? ` ${icon}` : ''}`}
                onClick={() => setToggle(!toggle)}
            >
                {text}
            </button>
            <div className={toggle ? styles.open : styles.close}>
                {children}
            </div>
        </div>
    )
};

export  {
    TOGGLE_ICONS,
}

export default Toggle;
